export function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}
